import * as React from "react";
const TargetedPopulationIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 48 48",
  fill: "currentColor",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m13.01 33.672-5.556 5.243a1.39 1.39 0 0 0 .009 2.062 1.643 1.643 0 0 0 2.21-.008l.003-.004 5.555-5.242a1.39 1.39 0 0 0-.008-2.062 1.642 1.642 0 0 0-2.21.007l-.004.004Zm21.74-18.981c.395 0 .773-.155 1.054-.433l5.393-5.333a1.5 1.5 0 1 0-2.11-2.133l-5.392 5.332a1.5 1.5 0 0 0 1.054 2.567Zm.71 18.73a1.445 1.445 0 0 0-2.036-.004 1.426 1.426 0 0 0-.008 2.02l5.124 5.14c.56.56 1.471.565 2.035.008a1.427 1.427 0 0 0 .009-2.025l-5.124-5.139ZM12.562 14.583c.562.56 1.467.556 2.024-.008a1.445 1.445 0 0 0-.008-2.035L9.44 7.417a1.426 1.426 0 0 0-2.024.008 1.445 1.445 0 0 0 .008 2.035l5.138 5.123ZM24.501 14c-5.416 0-9.5 3.801-9.5 8.842 0 .814.654 1.474 1.461 1.474.808 0 1.462-.66 1.462-1.474a5.495 5.495 0 0 1 2.923-4.97v22.654c0 .814.654 1.474 1.462 1.474.807 0 1.461-.66 1.461-1.474V29.474h1.462v11.052c0 .814.654 1.474 1.461 1.474s1.462-.66 1.462-1.474V17.872a5.495 5.495 0 0 1 2.923 4.97c0 .814.654 1.474 1.461 1.474.808 0 1.462-.66 1.462-1.474 0-5.04-4.084-8.842-9.5-8.842Zm3.5-5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
  clipRule: "evenodd"
}));
export default TargetedPopulationIcon;